<div class="div-exchange-sync" loading-spin [isLoading]="isSyncDisabled" [loadingSize]="'big'">
    <div class="sync-title">
        <label *ngIf="isFromAdminSetting">{{'exchange.firm_wise_auto_synchronization_settings' |
            stringLiterals}}</label>
        <label *ngIf="!isFromAdminSetting">{{'exchange.auto_synchronization_preferences' | stringLiterals}}</label>
        <smart-icon class="dialog-close" name="close" (click)="clickClose()">
        </smart-icon>
    </div>

    <div class="sync-info tam-form-field" *ngIf="isFromAdminSetting&&isShowCheckBoxField">
        <label>{{'exchange.choose_data_to_use' | stringLiterals}}</label>
        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [(ngModel)]="syncRule" #dropDownEl
            [data]="syncRules" class="exchange-input" (focus)="dropDownEl.toggle(true)"
            (mousedown)="$event.preventDefault()">
        </kendo-dropdownlist>
    </div>

    <div class="sync-info tam-form-field" *ngIf="isFromAdminSetting&&isShowCheckBoxField"
        [ngClass]="{'has-error': isShowDomianError}">
        <label>{{'exchange.please_enter_your_domain_name' | stringLiterals}}<span
                style="color:red;">&nbsp;*</span></label>
        <kendo-multiselect class="sync-domain-dropdown " [data]="domainData" [filterable]="true"
            [(ngModel)]="selectedDomainItems" (valueChange)="valueChangeDomain($event)" (keydown.esc)="onEnter($event)"
            (mousedown)="$event.preventDefault()">
        </kendo-multiselect>
        <div *ngIf="isShowDomianError" class="tam-form-help">
            {{'general.required_error_message' | stringLiterals}}
        </div>
    </div>

    <div class="exchange-sync-body" *ngIf="isShowCheckBoxField">
        <span>Contacts</span>
        <div class="exchange-sync-checkboxs">
            <div class="sync-checkbox">
                <label tam-checkbox class="exchange-checkbox" [(ngModel)]="syncToExchange"></label>
                <div class="checkbox-description">
                    <label class="exchange-label-1"> {{'exchange.enable_to_Exchange' | stringLiterals}}</label>
                    <label class="exchange-label-2">{{'exchange.with_this_option_selected' | stringLiterals}}</label>
                </div>
            </div>

            <div class="sync-checkbox">
                <label tam-checkbox class="exchange-checkbox" [(ngModel)]="syncToTamale"></label>
                <div class="checkbox-description">
                    <label class="exchange-label-1">{{'exchange.enable_auto_sync_new_contact_to_tamale' |
                        stringLiterals}}</label>
                    <label class="exchange-label-2">{{'exchange.imported_to_tamale_automatically' |
                        stringLiterals}}</label>
                </div>
            </div>

            <div class="sync-checkbox">
                <label tam-checkbox class="exchange-checkbox" [(ngModel)]="syncByUpdate"></label>
                <div class="checkbox-description">
                    <label class="exchange-label-1">{{'exchange.enable_auto_sync' | stringLiterals}} <span
                            class="exchange-span-dark">{{'exchange.connected_contacts' |
                            stringLiterals}}</span>{{'exchange.when_there_is_an_update' | stringLiterals}}</label>
                    <label class="exchange-label-2">{{'exchange.exchange_and_tamale_will_sync_your_contact' |
                        stringLiterals}} <span class="exchange-span-dark-low">{{currentSyncRule}}</span>.</label>
                </div>
            </div>
        </div>

    </div>
    <div class="exchange-sync-button">
        <div>
            <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button sync-cancel"
                (click)="clickClose()">
                {{'general.cancel' | stringLiterals}}</button>
            <button tam-button tamType="primary" tamSize="normal" class="dialog-button   sync-save"
                (click)="clickApply()" [disabled]="isSyncDisabled" [tamLoading]="isSyncDisabled">{{'general.apply' |
                stringLiterals}}</button>
        </div>
    </div>

</div>